import React from "react";

const EditPencilIcon = ({ width = 18, height = 18, stroke = "white", strokeWidth = 1.5 }) => (
  <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_602_2382)">
      <path
        d="M9.16432 3.84969L14.0213 7.33239M10.5118 1.81661C11.6128 0.356463 13.1396 1.13838 14.2949 1.96777C15.4501 2.79715 16.6695 3.98676 15.5685 5.44691L7.46864 15.7676C7.1341 16.2112 6.63174 16.5061 6.07328 16.5868L3.26491 16.9925C2.8816 17.0479 2.52422 16.7913 2.46432 16.4177L2.02545 13.6808C1.9382 13.1367 2.07729 12.5809 2.41185 12.1373L10.5118 1.81661Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_602_2382">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default EditPencilIcon;
